import React from 'react';
import PropTypes from 'prop-types';

import { FormatPrice } from 'utils/format';

import { Icon, Flexer } from '@ontruck/orc';

const OntruckMarginCell = ({ margin, showMargin, currency, ...props }) => {
  if (!showMargin) {
    return null;
  }

  return (
    <Flexer.Parent alignItems="center" {...props}>
      <Flexer.Child mRight="XS">
        <Icon glyph="moneybag" size="1.6rem" color="grey500" />
      </Flexer.Child>
      <Flexer.Child>
        <FormatPrice currency={currency} value={margin} />
      </Flexer.Child>
    </Flexer.Parent>
  );
};

OntruckMarginCell.propTypes = {
  margin: PropTypes.number,
  currency: PropTypes.string,
};

export default OntruckMarginCell;
